import React from 'react';
import PropTypes from 'prop-types';
import SharePieChart from './SharePieChart';
const PRShareChart = ({ data }) => {
    const chartData = data.map(element => ({
        developer: element.developer,
        totalPRs: element.totalMergedPrs + element.totalOpenPrs + element.totalDeclinedPrs,
        mergedPRs: element.totalMergedPrs,
        openPRs: element.totalOpenPrs,
        declinedPRs: element.totalDeclinedPrs,
    })).filter(element => element.totalPRs > 0);
    return chartData.length > 0 ? (
        <SharePieChart
            chartData={chartData}
            dataKey="totalPRs"
            labelFunction={(payload) => payload.totalPRs}
            type="pr"
            title="PRs by Developers"
        />
    ) : null;
};
PRShareChart.propTypes = {
    data: PropTypes.array.isRequired,
};
export default PRShareChart;